export default __webpack_public_path__ + "static/media/profile.21e1d250.svg";